import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { Card, CardContent } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Stethoscope } from 'lucide-react'

const SUPABASE_URL = (import.meta as any).env?.VITE_SUPABASE_URL || ''

export function SalaEsperaPage() {
  const { token } = useParams<{ token: string }>()
  const navigate = useNavigate()
  const [pulsando] = useState(true)
  const [medicoEntrou, setMedicoEntrou] = useState(false)
  const [medicoNome, setMedicoNome] = useState('médico')

  useEffect(() => {
    if (!token) return

    const checkSala = async () => {
      try {
        const res = await fetch(`${SUPABASE_URL}/functions/v1/validar-token-publico`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token }),
        })
        const data = await res.json()
        if (data.valido && data.consulta?.salaDailyUrl) {
          setMedicoEntrou(true)
          setMedicoNome(data.consulta.medicoNome || 'médico')
          setTimeout(() => {
            navigate(`/teleconsulta/${token}/chamada?sala=${encodeURIComponent(data.consulta.salaDailyUrl)}`)
          }, 1500)
        }
      } catch {
        // Silencioso — tenta novamente
      }
    }

    checkSala()
    const interval = setInterval(checkSala, 5000)
    return () => clearInterval(interval)
  }, [token, navigate])

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardContent className="space-y-6 p-6 text-center">
          <div
            className={`mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-primary/10 transition-all ${
              pulsando ? 'scale-110' : 'scale-100'
            }`}
            style={{ animation: pulsando ? 'pulse 2s infinite' : 'none' }}
          >
            <Stethoscope className="h-10 w-10 text-primary" />
          </div>

          <div>
            <h1 className="text-xl font-semibold">
              {medicoEntrou ? 'O médico entrou!' : 'Sala de Espera'}
            </h1>
            <p className="mt-2 text-muted-foreground">
              {medicoEntrou
                ? `Dr(a). ${medicoNome} está pronto. Redirecionando para a consulta...`
                : 'Você está na sala de espera. Aguarde o médico iniciar a consulta.'}
            </p>
          </div>

          <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground">
            <div className={`h-2 w-2 rounded-full ${medicoEntrou ? 'bg-green-500' : 'animate-pulse bg-green-500'}`} />
            {medicoEntrou ? 'Entrando na consulta...' : 'Online'}
          </div>

          <Button
            variant="outline"
            className="w-full"
            onClick={() => navigate(`/teleconsulta/${token}/chamada`)}
          >
            Entrar na Chamada (teste)
          </Button>
        </CardContent>
      </Card>

      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.8; transform: scale(1.05); }
        }
      `}</style>
    </div>
  )
}
